import { CountUp } from 'countup.js';

/**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 **/
const counts = Array.from(document.getElementsByClassName('count-up'));
if (counts) {
  const defaultOptions = {
    separator: ',', // Розділювач для тисяч
    enableScrollSpy: true,
    scrollSpyRunOnce: true,
    decimalPlaces: 0 // За замовчуванням 0 десяткових знаків
  };

  let idNumber = 1;

  counts.forEach((count) => {
    const id = `count-up-${idNumber}`,
      value = parseFloat(count.innerHTML); // Отримуємо значення

    let optionsFromDataAttr = { ...count.dataset };

    for (const key in optionsFromDataAttr) {
      if (optionsFromDataAttr[key] === '') {
        optionsFromDataAttr[key] = true;
      }
    }

    // Якщо значення має десяткові місця, додаємо відповідну опцію
    if (value % 1 !== 0) {
      optionsFromDataAttr.decimalPlaces = 1; // 1 десяткове місце для нецілих чисел
    }

    count.id = id;
    new CountUp(
      id,
      value,
      Object.assign(Object.assign({}, defaultOptions), optionsFromDataAttr)
    ).start(); // Запускаємо підрахунок
    idNumber++;
  });
}
